import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCStatusAccountComponent = class UiCStatusAccountComponent {
    constructor() {
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.resendEmail = new EventEmitter();
        this.isBack = true;
    }
    goBack() {
        this.back.emit();
    }
    goContinue() {
        this.continue.emit();
    }
    resendContract() {
        this.resendEmail.emit();
    }
    prepareStatusPartners(status) {
        switch (status) {
            case 'WAITING_TO_ACCEPT_TERMS':
                return 'ONBORDING.V2.TEXT.TITLE.WAITING_TO_ACCEPT_TERMS';
            case 'WAITING_TO_ACCEPT_TERMS_AND_PASSWORD_SETTING':
                return 'ONBORDING.V2.TEXT.TITLE.WAITING_TO_ACCEPT_TERMS_AND_PASSWORD_SETTING';
            case 'FINISHED':
                return 'ONBORDING.V2.TEXT.TITLE.FINISHED';
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusAccountComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusAccountComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusAccountComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCStatusAccountComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCStatusAccountComponent.prototype, "listPartnersContract", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCStatusAccountComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCStatusAccountComponent.prototype, "continue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCStatusAccountComponent.prototype, "resendEmail", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCStatusAccountComponent.prototype, "isBack", void 0);
UiCStatusAccountComponent = __decorate([
    Component({
        selector: 'ui-c-status-account',
        template: "<div class=\"animation-type\">\n  <div id=\"contract\">\n    <ui-c-header-onboarding [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title\" [description]=\"description\"\n      [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" (back)=\"goBack()\"></ui-c-header-onboarding>\n    <ion-row class=\"ion-justify-content-center ion-align-items-center\">\n      <ion-col size=\"12\" size-lg=\"12\" size-xl=\"12\">\n        <ion-row class=\"row-btn-header ion-align-items-center ion-text-center\">\n          <ion-col size=\"12\">\n            <h4>{{ 'ONBORDING.V2.TEXT.TITLE.LIST_PARTNERS' | wlpTranslate }} </h4>\n          </ion-col>\n        </ion-row>\n      </ion-col>\n\n      <ion-col *ngFor=\"let partner of listPartnersContract\" size=\"12\" size-lg=\"12\" size-xl=\"12\">\n        <ion-row class=\"row-btn\">\n          <ion-col class=\"row-btn ion-align-items-center ion-text-left\" [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n            <ion-label><span class=\"font-family-semibold\">{{ 'ONBORDING.V2.FORM.LABEL.NAME' | wlpTranslate}}:</span> {{partner?.name}} <br>\n              <span class=\"font-family-semibold\">{{ 'ONBORDING.V2.FORM.LABEL.DOCUMENT' | wlpTranslate }}:</span> {{partner?.document}} <br>\n              <span class=\"font-family-semibold\">{{ 'ONBORDING.V2.FORM.LABEL.EMAIL' | wlpTranslate }}:</span> {{partner?.email}}\n            </ion-label>\n          </ion-col>\n          <ion-col class=\"d-flex ion-align-items-center ion-justify-content-center ion-text-center font-family-semibold\"\n            [size]=\"12\" [sizeMd]=\"6\" [sizeSm]=\"6\">\n            <ion-label class=\"w-10\">\n              <span>\n                {{prepareStatusPartners(partner?.status) | wlpTranslate}}\n              </span>\n            </ion-label>\n          </ion-col>\n        </ion-row>\n      </ion-col>\n    </ion-row>\n    <ion-row class=\"ion-justify-content-center ion-margin-top status-btn-responsive\">\n      <ion-col style=\"width: 100% !important; max-width: unset !important;\" [size]=\"12\" [sizeMd]=\"6\">\n        <ui-c-button data-cy=\"onboarding-endflow-continue-btn\" expand=\"block\" (click)=\"goContinue()\">\n          {{ 'ONBORDING.V2.BUTTON.CONTINUE' | wlpTranslate }}\n        </ui-c-button>\n      </ion-col>\n      <ion-col style=\"width: 100% !important; max-width: unset !important;\" [size]=\"12\" [sizeMd]=\"6\">\n        <ui-c-button expand=\"block\" (click)=\"resendContract()\" [disabled]=\"false\">\n          {{'ONBORDING.V2.BUTTON.EMAIL_PARTNERS' | wlpTranslate}}\n        </ui-c-button>\n      </ion-col>\n    </ion-row>\n  </div>\n"
    })
], UiCStatusAccountComponent);

let UiCStatusAccountModule = class UiCStatusAccountModule {
};
UiCStatusAccountModule = __decorate([
    NgModule({
        declarations: [UiCStatusAccountComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCHeaderOnboardingModule
        ],
        exports: [UiCStatusAccountComponent]
    })
], UiCStatusAccountModule);

export { UiCStatusAccountComponent, UiCStatusAccountModule };
//# sourceMappingURL=wlp-ui-c-status-account.js.map
